import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AppLayoutComponent } from './layout/app/app-layout';
import { EmptyLayoutComponent } from './layout/empty/empty-layout';

export const routes: Routes = [
  {
    path: 'auth',
    component: EmptyLayoutComponent,
    children: [
      {
        path: "login-failed",
        loadComponent: () => import("./features/auth/login-failed/login-failed").then(m => m.LoginFailed),
      },
      {
        path: 'signed-out',
        loadComponent: () => import('./features/auth/signed-out/signed-out').then(m => m.SignedOut),
      },
    ],
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/dashboard').then(m => m.Dashboard),
      },
      {
        path: 'clients',
        loadComponent: () => import('./features/clients/clients').then(m => m.Clients),
      },
      {
        path: 'new-client',
        loadComponent: () => import('./features/clients/new-client/new-client').then(m => m.NewClient),
      },
      {
        path: 'clients/:id',
        loadComponent: () => import('./features/clients/client-detail/client-detail').then(m => m.ClientDetailComponent),
      },
      {
        path: 'tenants',
        loadComponent: () => import('./features/tenants/tenants').then(m => m.Tenants),
      },
      {
        path: 'new-tenant',
        loadComponent: () => import('./features/tenants/new-tenant/new-tenant').then(m => m.NewTenant),
      },
      {
        path: 'tenants/:id',
        loadComponent: () => import('./features/tenants/tenant-detail/tenant-detail').then(m => m.TenantDetail),
      },
      {
        path: 'authorization-requests',
        loadComponent: () => import('./features/authorization-requests/authorization-requests').then(m => m.AuthorizationRequests),
      },
      {
        path: 'authorization-requests/:id',
        loadComponent: () => import('./features/authorization-requests/authorization-request-detail/authorization-request-detail').then(m => m.AuthorizationRequestDetailComponent),
      }
    ]
  }
];
